import styles from './with-tooltip.module.css';
import { WithTooltipProps } from './with-tooltip.props';

export const WithTooltip = ({ component: Component, tooltip }: WithTooltipProps) => {
	return (
		<div className={styles.wrapper}>
			<Component className={styles.tooltipComponent} />
			<div className={styles.tooltipWrapper}>
				<p className={styles.label}>{tooltip}</p>
			</div>
		</div>
	);
};
